import Vue from 'vue'
import Vuex from 'vuex'
import Parse from 'parse'

// https://www.mikestreety.co.uk/blog/vue-js-using-localstorage-with-the-vuex-store

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    connected: null, // network status
    readCache: false, // read from cache?
    device: null, // device Parse Object
    user: null, // logged user Parse Object
    site: null,
    wsStatus: null
  },
  actions: {

  },
  mutations: {
    saveSite (state, site) {
      console.log('Site updated', site)
      localStorage.setItem('site', JSON.stringify(site))
      state.site = null // https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
      state.site = site
    },
    saveDevice (state, device) {
      localStorage.setItem('device', JSON.stringify(device))
      state.device = null
      state.device = device
    },
    setConnected (state, status) {
      state.connected = status
    },
    setReadCache (state, status) {
      state.readCache = status
    },
    saveUser (state, user) {
      state.user = null
      state.user = user
    },
    setWsStatus (state, status) {
      state.wsStatus = status
    },
  },
  getters: {
    user: state => {
      return state.user
    },
    device: state => {
      let result = null
      if (state.device) {
        result = state.device
      } else {
        let item = localStorage.getItem('device')
        if (item) {
          let json = JSON.parse(item)
          if (json) {
            json.className = 'Device'
            result = Parse.Object.fromJSON(json, false)
          }
        }
      }
      return result
    },
    site: state => {
      let result = null
      if (state.site) {
        result = state.site
      } else {
        let item = localStorage.getItem('site')
        if (item) {
          let json = JSON.parse(item)
          if (json) {
            json.className = 'Site'
            result = Parse.Object.fromJSON(json, false)
          }
        }
      }
      console.log('Get site', result)
      return result
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/tools/store/index.js